import EmptyList from 'components/Bookings2/UI/EmptyList';
import Spinner from 'components/UI/V3/Spinner';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { Table } from 'components/UI/V3/Table/Table';
import { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';
import BelongingsTableRow from './BelongingsTableRow';
import styles from './BelongingsTable.module.scss';
import { TableColumnSort } from 'utils/tableSort';

export type BelongingsSortField = 'pet_name' | 'belonging' | 'date' | 'room' | 'note';

const BELONGINGS_COLUMN_COUNT = 5;

interface BelongingsTableProps {
    items: Array<any>;
    isLoading?: boolean;
    className?: string;
    sort?: TableColumnSort<BelongingsSortField>;
    onSort?: (field: BelongingsSortField) => void;
}

export const BelongingsTable: FunctionComponent<BelongingsTableProps> = ({
    items,
    isLoading,
    className,
    sort,
    onSort
}) => {
    const isMobile = useMediaQuery({ query: '(max-width:600px)' });

    if (!isLoading && items.length === 0) {
        return <EmptyList variant="upcoming" />;
    }

    return (
        <Table
            className={className}
            fullHeight={true}
            pagination={{ page: 1, size: 10, totalPages: 1 }}
            onPageChange={() => {}}
            onSizeChange={() => {}}
        >
            {!isMobile && (
                <TableHeader>
                    <TableHeaderCell
                        sortDirection={sort?.field === 'pet_name' ? sort.direction : undefined}
                        onSort={() => onSort?.('pet_name')}
                    >
                        Pet
                    </TableHeaderCell>
                    <TableHeaderCell
                        sortDirection={sort?.field === 'belonging' ? sort.direction : undefined}
                        onSort={() => onSort?.('belonging')}
                    >
                        Belongings
                    </TableHeaderCell>
                    <TableHeaderCell
                        sortDirection={sort?.field === 'date' ? sort.direction : undefined}
                        onSort={() => onSort?.('date')}
                    >
                        Date
                    </TableHeaderCell>
                    <TableHeaderCell
                        sortDirection={sort?.field === 'room' ? sort.direction : undefined}
                        onSort={() => onSort?.('room')}
                    >
                        Room
                    </TableHeaderCell>
                    <TableHeaderCell
                        sortDirection={sort?.field === 'note' ? sort.direction : undefined}
                        onSort={() => onSort?.('note')}
                    >
                        Notes
                    </TableHeaderCell>
                </TableHeader>
            )}
            <TableBody>
                {isLoading ? (
                    <TableRow>
                        <TableCell
                            colSpan={BELONGINGS_COLUMN_COUNT}
                            className={styles.spinnerContainer}
                        >
                            <Spinner />
                        </TableCell>
                    </TableRow>
                ) : (
                    items.map(item => (
                        <BelongingsTableRow
                            key={item.id}
                            item={item}
                        />
                    ))
                )}
            </TableBody>
        </Table>
    );
};

export default BelongingsTable;
